/**
 * HelpTarget — wraps any element. When help mode is active and mouse enters,
 * sets the hoveredId in useHelpStore so HelpPanel shows the description.
 *
 * Usage: <HelpTarget id="toolbar.save"><button>Save</button></HelpTarget>
 *
 * Can also be used inline: <HelpTarget id="toolbar.save" inline>...</HelpTarget>
 */
import { useCallback } from 'react';
import { useHelpStore } from '../store/useHelpStore';

export default function HelpTarget({ id, children, className = '', inline = false }) {
  const isHelpMode = useHelpStore(s => s.isHelpMode);
  const setHovered = useHelpStore(s => s.setHovered);
  const clearHovered = useHelpStore(s => s.clearHovered);

  const handleMouseEnter = useCallback(() => {
    if (isHelpMode) setHovered(id, null);
  }, [isHelpMode, id, setHovered]);

  const handleMouseLeave = useCallback(() => {
    if (isHelpMode) clearHovered();
  }, [isHelpMode, clearHovered]);

  const Tag = inline ? 'span' : 'div';

  return (
    <Tag
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`${className} ${isHelpMode ? 'cursor-help' : ''}`}
    >
      {children}
    </Tag>
  );
}
